import { ObjectMapper } from 'json-object-mapper';
import { IModel } from './IModel';

export class CountryModel implements IModel<CountryModel> {
  public code = '';
  public name = '';
  public phoneCode = '';

  static create(input: any): CountryModel {
    return ObjectMapper.deserialize<CountryModel>(CountryModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
